
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  "version": "0.0.1",
  "hash": "746b8894d093780d49da52f94b09d8e4f4782e65"
};
/* tslint:enable */
  